import { ALERT, GET_SECONDARY_SUB_CATEGORY, REMOVE_ALERT,GET_NEXT_SECONDARY_SUB_CATEGORY,GET_NEW_SUB_CATEGORY } from "./actionType";
import {
  getDataAPI,
  postDataAPI,
  deleteData,
  patchDataApi,
} from "../../services/apiWrapper";

import { toast } from "react-toastify";

export const postNextSecondarySubCategoryAdd = (obj) => async (dispatch) => {
  try {
    //   dispatch({ type: ALERT, payload: { loading: true } });
    const response = await dispatch(postDataAPI(`nextsubcategory`, obj));
    if (response) {
      toast.success("Next Secondary Subcategory Added successfully");
      // dispatch({ type: ALERT, payload: { loading: false } });
      return response.data;
    }
  } catch (error) {
    toast.error("please fill all field");
    //   dispatch({ type: ALERT, payload: { loading: false } });
    return false;
  }
};
export const getNextSecondarySubCategory = () => async (dispatch) => {
  try {
    dispatch({
      type: ALERT,
      payload: { loading: true },
    });

    // Include the 'id' as a parameter in the API URL
    const response = await dispatch(getDataAPI(`nextsubcategory`));

    dispatch({ type: GET_SECONDARY_SUB_CATEGORY, payload: response.data });
    console.log(response, "category");
  } catch (error) {
    // dispatch({ type: ALERT, payload: { error: error.message } });
    console.warn(error);
    setTimeout(() => {
      dispatch({ type: REMOVE_ALERT });
    }, 5000);
  }
};
export const postNextSecondarySubCategoryManage = (queryParams) => async (dispatch) => {
  try {
    // Assuming queryParams is an object with keys like "currentPage" and "itemsPerPage"
    const queryParamsString = new URLSearchParams(queryParams).toString();

    const response = await dispatch(
      postDataAPI(`nextsubcategory/getnextsecondarysubcategory?${queryParamsString}`)
    );

    if (response) {
      // toast.success('Category Added successfully');
      return response;
    }
  } catch (error) {
    //   toast.error('Please fill all fields');
    return false;
  }
};

export const deleleteNextSecondarySubCategory = (id) => async (dispatch) => {
  try {
    //   dispatch({ type: ALERT, payload: { loading: true } });
    const response = await dispatch(deleteData(`nextsubcategory/${id}`));
    if (response) {
      toast.success("Sub Category deleted Successfully");
      // dispatch({ type: ALERT, payload: { loading: false } });
      return response.data;
    }
  } catch (error) {
    toast.error("please fill all field");
    //   dispatch({ type: ALERT, payload: { loading: false } });
    return false;
  }
};

export const getNextSecondarySubCategorys = (id) => async (dispatch) => {
  try {
    //   dispatch({ type: ALERT, payload: { loading: true } });
    const response = await dispatch(getDataAPI(`nextsubcategory/${id}`));
    if (response) {
      return response;
    }
  } catch (error) {
    // toast.error('please fill all field');
    //   dispatch({ type: ALERT, payload: { loading: false } });
    return false;
  }
};
// http://127.0.0.1:8080/category/64dddda1067e95cd77eb87c1
export const postNextSecondarySubCategoryUpdate = (id, data) => async (dispatch) => {
  try {
    //   dispatch({ type: ALERT, payload: { loading: true } });
    const response = await dispatch(patchDataApi(`nextsubcategory/${id}`, data));
    if (response) {
      toast.success("Category updated Successfully");
      // dispatch({ type: ALERT, payload: { loading: false } });
      return response.data;
    }
  } catch (error) {
    toast.error("please fill all field");
    //   dispatch({ type: ALERT, payload: { loading: false } });
    return false;
  }
};



export const getNextSecondarySubCategoryByParent = (subParent) => async (dispatch) => {
  try {
    dispatch({
      type: ALERT,
      payload: { loading: true },
    });
    // Include the 'parentId' as a query parameter in the API URL
    // const response = await axios.get(`sub-category`);
    const response = await dispatch(getDataAPI(`nextsubcategory?subParent=${subParent}`));
    dispatch({ type: GET_NEXT_SECONDARY_SUB_CATEGORY, payload: response.data });
    console.log(response, "secondary sub category");
  } catch (error) {
    // Handle the error
    console.warn(error);
    setTimeout(() => {
      dispatch({ type: REMOVE_ALERT });
    }, 5000);
  }
};
export const getNewSubCategoryByParent = (secondDisplayNameId) => async (dispatch) => {
  try {
    dispatch({
      type: ALERT,
      payload: { loading: true },
    });
    // Include the 'parentId' as a query parameter in the API URL
    // const response = await axios.get(`sub-category`);
    const response = await dispatch(getDataAPI(`nextsecondarysubcategory?secondDisplayNameId=${secondDisplayNameId}`));
    dispatch({ type: GET_NEW_SUB_CATEGORY, payload: response.data });
    console.log(response, "new sub category");
  } catch (error) {
    // Handle the error
    console.warn(error);
    setTimeout(() => {
      dispatch({ type: REMOVE_ALERT });
    }, 5000);
  }
};